export const GiftIcon = () => (
  <svg
    width="13px"
    height="15px"
    viewBox="0 0 13 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{
      width: "auto",
      height: "20px",
    }}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-297.000000, -552.000000)"
        fill="#242424"
        fillRule="nonzero"
      >
        <g transform="translate(265.000000, 545.000000)">
          <g>
            <g transform="translate(32.000000, 7.000000)">
              <path d="M10.8333333,8.57142857 L10.8333333,13.9285714 L7.04166667,13.9285714 L7.04166667,8.57142857 L10.8333333,8.57142857 Z M5.95833333,8.57142857 L5.95833333,13.9285714 L2.16666667,13.9285714 L2.16666667,8.57142857 L5.95833333,8.57142857 Z M11.9166667,5.35714286 L11.9166667,7.5 L7.04166667,7.5 L7.04166667,5.35714286 L11.9166667,5.35714286 Z M5.95833333,5.35714286 L5.95833333,7.5 L1.08333333,7.5 L1.08333333,5.35714286 L5.95833333,5.35714286 Z M4.0625,1.07142857 C4.67458333,1.07142857 5.21029167,1.48339286 5.36575,2.07375 L5.80179167,3.75 L4.060875,3.75 C3.315,3.74946429 2.70833333,3.14839286 2.70833333,2.41071429 C2.70833333,1.6725 3.31554167,1.07142857 4.0625,1.07142857 L4.0625,1.07142857 Z M8.92666667,2.19642857 C9.18666667,2.01321429 9.51004167,1.98482143 9.80145833,2.12357143 C10.1085833,2.26928571 10.2916667,2.5575 10.2916667,2.89446429 C10.2916667,3.36642857 9.90383333,3.75 9.426625,3.75 L7.642375,3.75 L8.92666667,2.19642857 Z M13,4.28571429 L10.7677917,4.28571429 C11.1399167,3.93482143 11.375,3.4425 11.375,2.89446429 C11.375,2.14714286 10.9519583,1.48178571 10.2705417,1.15767857 C9.59020833,0.834642857 8.79991667,0.923035714 8.2095,1.39017857 L6.76,3.13392857 L6.4155,1.80642857 L6.41495833,1.80482143 C6.13491667,0.741964286 5.16804167,0 4.0625,0 C2.718625,0 1.625,1.08160714 1.625,2.41071429 C1.625,3.17142857 1.99116667,3.84375 2.549625,4.28571429 L0,4.28571429 L0,8.57142857 L1.08333333,8.57142857 L1.08333333,15 L11.9166667,15 L11.9166667,8.57142857 L13,8.57142857 L13,4.28571429 Z"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
